export const providerIcons:Record<string,string>={
  "openai": "/brand/providers/openai.com.ico",
  "anthropic": "/brand/providers/claude.com.png",
  "zai": "/brand/providers/z.ai.svg",
  "moonshot": "/brand/providers/www.kimi.com.png",
  "meta": "/brand/providers/ai.meta.com.svg",
  "tencent": "/brand/providers/www.tencent.com.svg",
  "xai": "/brand/providers/x.ai.ico",
  "opencode": "/brand/providers/opencode.ai.png",
  "research-r4-coder": "/brand/providers/r4.codes.ico",
  "research-command-code": "/brand/providers/commandcode.ai.svg",
  "research-runinfra": "/brand/providers/runinfra.ai.svg",
  "research-vercel-ai-gateway": "/brand/providers/vercel.com.png",
  "research-cloudflare": "/brand/providers/developers.cloudflare.com.png",
  "research-deepinfra": "/brand/providers/deepinfra.com.png",
  "research-kilo": "/brand/providers/kilo.ai.png",
  "research-aigateway.sh": "/brand/providers/aigateway.sh.png",
  "research-sanad": "/brand/providers/www.sanad.dev.svg",
  "research-tencent-tokenhub": "/brand/providers/cloud.tencent.com.ico",
  "research-openai": "/brand/providers/developers.openai.com.png",
  "research-anthropic": "/brand/providers/platform.claude.com.svg",
  "research-google": "/brand/providers/ai.google.dev.png",
  "research-fireworks": "/brand/providers/docs.fireworks.ai.svg",
  "research-baseten": "/brand/providers/www.baseten.co.png",
  "research-parasail": "/brand/providers/www.parasail.io.png",
  "research-together-ai": "/brand/providers/vercel.com.png",
  "research-siliconflow": "/brand/providers/www.siliconflow.com.png",
  "research-vercel-morph": "/brand/providers/vercel.com.png",
  "research-vercel-parasail": "/brand/providers/vercel.com.png",
  "research-vercel-novita": "/brand/providers/vercel.com.png",
  "research-vercel-wafer": "/brand/providers/vercel.com.png",
  "research-vercel-friendliai": "/brand/providers/vercel.com.png",
  "research-openrouter": "/brand/providers/openrouter.ai.png",
  "research-b.ai": "/brand/providers/docs.bankofai.io.ico",
  "research-cheaper-inference": "/brand/providers/www.cheaperinference.com.svg",
  "research-akashml": "/brand/providers/akashml.com.svg",
  "research-ofoxai": "/brand/providers/ofox.ai.svg",
  "research-gptproto": "/brand/providers/gptproto.com.ico",
  "research-neuralwatt": "/brand/providers/portal.neuralwatt.com.png",
  "research-ollama": "/brand/providers/ollama.com.png",
  "research-umans": "/brand/providers/app.umans.ai.png",
  "research-llm-gateway-devpass": "/brand/providers/devpass.llmgateway.io.ico",
  "research-alibaba-model-studio": "/brand/providers/www.alibabacloud.com.webp",
  "research-google-gemini": "/brand/providers/ai.google.dev.png",
  "deepseek": "/brand/providers/www.deepseek.com.ico",
  "cursor": "/brand/providers/cursor.com.svg"
};
